import React from "react";
import {camelize} from "../../utils/stringUtils";

type LabelProps = {
    id?: string,
    label: string,
    required?: boolean
    className?: string,
    labelId?: string,
    htmlFor?: string
}
export const Label: React.FC<LabelProps> = ({id, label, required, className, labelId= label, htmlFor}) => {
    const camelLabel = camelize(label);
    const classes = className ?? `h5 label ${camelLabel}Label`;
    return (
        <label className={classes} htmlFor={htmlFor ?? camelLabel} id={id ?? labelId}>
            {label}    {required && <a className="color-text--error">*</a>}
        </label>
    );
}